function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0.000244141C6.0371 0.00777353 2.45253 2.35476 0.860944 5.98401C-0.730643 9.61326 -0.0289285 13.84 2.65 16.7602C4.54316 18.8124 7.20801 19.9796 10 19.9796C12.792 19.9796 15.4568 18.8124 17.35 16.7602C20.0289 13.84 20.7306 9.61326 19.1391 5.98401C17.5475 2.35476 13.9629 0.00777353 10 0.000244141ZM10 18.0004C7.92847 17.9972 5.93892 17.1906 4.45 15.7504C5.37453 13.4997 7.56681 12.0302 10 12.0302C12.4332 12.0302 14.6255 13.4997 15.55 15.7504C14.0611 17.1906 12.0715 17.9972 10 18.0004ZM8.00001 8.00024C8.00001 6.89567 8.89544 6.00024 10 6.00024C11.1046 6.00024 12 6.89567 12 8.00024C12 9.10481 11.1046 10.0002 10 10.0002C8.89544 10.0002 8.00001 9.10481 8.00001 8.00024ZM16.91 14.0005C16.0165 12.4722 14.6414 11.2835 13 10.6205C14.4182 9.01237 14.3162 6.57201 12.7687 5.08785C11.2213 3.6037 8.77876 3.6037 7.23128 5.08785C5.68379 6.57201 5.58178 9.01237 7.00001 10.6205C5.35861 11.2835 3.98348 12.4722 3.09001 14.0005C2.37795 12.7876 2.00173 11.407 2.00001 10.0005C2.00001 5.58221 5.58173 2.00049 10 2.00049C14.4183 2.00049 18 5.58221 18 10.0005C17.9983 11.407 17.6221 12.7876 16.91 14.0005Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/user.bff48c61.svg";
export { SvgComponent as ReactComponent };